import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductionPlanningComponent } from './production-planning/production-planning.component';
import { PurchasePlanningComponent } from './purchase-planning/purchase-planning.component';
import { ConsolidatedStockTransactionsComponent } from './consolidated-stock-transactions/consolidated-stock-transactions.component';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { StockBreakdownComponent } from './stock-breakdown/stock-breakdown.component';
import { MaterialAvailabilityCheckComponent } from './material-availability-check/material-availability-check.component';
import { PurchaseHistoryComponent } from './purchase-history/purchase-history.component';
import { SupplierComparisonComponent } from './supplier-comparison/supplier-comparison.component';
import { MaterialUsageTrendComponent } from './material-usage-trend/material-usage-trend.component';
import { ConsumptionAnalysisComponent } from './consumption-analysis/consumption-analysis.component';
import { ItemTransactionLogComponent } from './item-transaction-log/item-transaction-log.component';
import { RptInvMtlAvailabilityComponent } from './rpt-inv-mtl-availability/rpt-inv-mtl-availability.component';
import { RptPrdProdnOutputComponent } from './rpt-prd-prodn-output/rpt-prd-prodn-output.component';
import { RptPrdConsumptionAnalysisComponent } from './rpt-prd-consumption-analysis/rpt-prd-consumption-analysis.component';
import { RptPrdRejectionAnalysisComponent } from './rpt-prd-rejection-analysis/rpt-prd-rejection-analysis.component';
import { RptNonMovingItemsComponent } from './rpt-non-moving-items/rpt-non-moving-items.component';
import { StockAnalysisComponent } from './stock-analysis/stock-analysis.component';
import { BatchAnalysisComponent } from './batch-analysis/batch-analysis.component';
import { RptInvMultiMtlRequirementComponent } from './rpt-inv-multi-mtl-requirement/rpt-inv-multi-mtl-requirement.component';


const routes: Routes = [

    { path: 'productionplanning', component: ProductionPlanningComponent },
    { path: 'purchaseplanning', component: PurchasePlanningComponent },
    { path: 'ConsolidatedStockTransactions', component: ConsolidatedStockTransactionsComponent },
    { path: 'TransactionHistory', component: TransactionHistoryComponent },
    { path: 'stock-breakdown', component: StockBreakdownComponent },
    { path: 'materialavailabilitycheck', component: MaterialAvailabilityCheckComponent },
    { path: 'purchasehistory', component: PurchaseHistoryComponent },
    { path: 'suppliercomparison', component: SupplierComparisonComponent },
    { path: 'materialusagetrend', component: MaterialUsageTrendComponent },
    { path: 'consumptionanalysis', component: ConsumptionAnalysisComponent },
    { path: 'ItemTrasactionLog', component: ItemTransactionLogComponent },
    { path: 'RptInvMtlAvailability', component: RptInvMtlAvailabilityComponent },
    { path: 'RptPrdProdnOutput', component: RptPrdProdnOutputComponent },
    { path: 'RptPrdConsumptionAnalysis', component:RptPrdConsumptionAnalysisComponent},
    { path: 'RptPrdRejectionAnalysis', component: RptPrdRejectionAnalysisComponent},
    { path: 'RptNonMovingItems', component: RptNonMovingItemsComponent},
    { path: 'RptStockShortfall', component: StockAnalysisComponent},
    { path: 'RptBatchAnalysis', component: BatchAnalysisComponent},
    { path: 'RptInvMultiMtlRequirement', component: RptInvMultiMtlRequirementComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class ReportsRoutingModule { }